export default "__VITE_ASSET__BbNfs02N__"